/* eslint-disable react/no-unused-state */
import React, { Component, PropTypes } from 'react'
import classnames from 'classnames'
// import Moment from 'moment'
import { format } from 'date-fns'
import Alert from 'components/Alert'
import Table from 'components/Table'
import Heading from 'components/Heading'
import Card from 'components/Card'
import CardFooter from 'components/CardFooter'
import Button from 'components/Button'
import Dialog from 'components/Dialog'
import { hasAccess } from 'utils/hasAccess'
import constants from 'constants'

const styles = Object.assign(
  {},
  require('./BeneficiaryList.scss'),
  { columns: require('../../columns.scss') },
  { table: require('components/Table/Table.scss') },
)

const headerStyles = classnames(styles.table.unSortable)

class BeneficiaryList extends Component {
  static propTypes = {
    beneficiaries: PropTypes.object.isRequired,
    beneficiaryItems: PropTypes.instanceOf(Array),
    beneficiaryLocked: PropTypes.bool,
    beneficiaryYear: PropTypes.string,
    confirmBeneficiary: PropTypes.func,
    currentFy: PropTypes.bool.isRequired,
    currentUser: PropTypes.object.isRequired,
    deleteBeneficiary: PropTypes.func,
    openBeneficiaryCommentForm: PropTypes.func,
    openBeneficiaryForm: PropTypes.func,
    subHeading: PropTypes.bool,
  }
  static defaultProps = {
    beneficiaryItems: {},
    beneficiaryLocked: false,
    beneficiaryYear: '',
    confirmBeneficiary: null,
    deleteBeneficiary: null,
    openBeneficiaryCommentForm: null,
    openBeneficiaryForm: null,
    subHeading: false,
  }
  constructor(props) {
    super(props)
    this.state = {
      confirmBeneficiaryDeleteDialogOpen: false,
      confirmBeneficiaryDialogOpen: false,
      submit: false,
    }
  }

  _openConfirmBeneficiaryDeleteDialog = () => {
    this.setState({ confirmBeneficiaryDeleteDialogOpen: true })
  }

  _closeConfirmBeneficiaryDeleteDialog = () => {
    this.setState({ confirmBeneficiaryDeleteDialogOpen: false })
  }

  _saveConfirmBeneficiaryDeleteDialog = () => {
    this.setState({
      confirmBeneficiaryDeleteDialogOpen: false,
      submit: true,
    })
    const body = {
      beneficiary_id: this.props.beneficiaries.beneficiary.beneficiaryId,
      employee_id: this.props.beneficiaries.beneficiary.employeeId,
      loginname: '', // Login are stored on the WEB API serverside
    }
    if (!this.props.beneficiaryLocked) {
      this.props.deleteBeneficiary(body)
    }
  }

  _openConfirmBeneficiaryDialog = () => {
    this.setState({ confirmBeneficiaryDialogOpen: true })
  }

  _closeConfirmBeneficiaryDialog = () => {
    this.setState({ confirmBeneficiaryDialogOpen: false })
  }

  _saveConfirmBeneficiaryDialog = () => {
    this.setState({
      confirmBeneficiaryDialogOpen: false,
      submit: true,
    })
    const body = {
      employee_id: this.props.beneficiaries.beneficiary.employeeId,
      year: this.props.beneficiaries.currentFy.current.year,
      loginname: '', // Login are stored on the WEB API serverside
    }
    if (!this.props.beneficiaryLocked) {
      this.props.confirmBeneficiary(body)
    }
  }

  _returnBeneficiaryName = (beneficiary) => {
    if (!beneficiary || !beneficiary.type) {
      return beneficiary && beneficiary.firstName ? beneficiary.firstName : ''
    }
    const type = beneficiary.type.toLowerCase()
    if (type === constants.BENEFICIARY.TYPE.INDIVIDUAL.toLowerCase()) {
      const firstName = beneficiary.firstName || ''
      const lastName = beneficiary.lastName || ''
      return (`${firstName} ${lastName}`).trim()
    }
    if (type === constants.BENEFICIARY.TYPE.COMPANY.toLowerCase()) {
      return beneficiary.companyName || ''
    }
    if (type === constants.BENEFICIARY.TYPE.TRUST.toLowerCase()) {
      const trustName = beneficiary.trustName || ''
      // const trusteeName = beneficiary.trusteeName || ''
      return (`${trustName}`).trim()
    }
    return beneficiary.firstName || ''
  }

  renderCols = () => {
    return (
      <tr>
        <th className={classnames(styles.columns.name, headerStyles)}>Beneficiary name</th>
        <th className={classnames(styles.columns.dob, headerStyles)}>DOB</th>
        <th className={classnames(styles.columns.tfn, headerStyles)}>TFN</th>
        <th className={classnames(styles.columns.type, headerStyles)}>Type</th>
        <th className={classnames(styles.columns.amountType, headerStyles)}>Amount type</th>
        <th className={classnames(styles.columns.amountAlocated, headerStyles)}>Amount allocated</th>
      </tr>
    )
  }

  renderData = () => {
    return (
      this.props.beneficiaryItems.length ?
        this.props.beneficiaryItems.map(beneficiary => (
          <tr className={styles.base} key={beneficiary.beneficiaryId}>
            <td className={styles.nameCell}>
              {this._returnBeneficiaryName(beneficiary)}
            </td>
            <td className={styles.columns.dob}>
              {beneficiary.dob ? format(new Date(beneficiary.dob), constants.DATE_FORMAT.STANDARD_AU_FULLMONTH) : ''}
            </td>
            <td>
                {beneficiary.type === 'Minor' ? '' : beneficiary.tfn}
            </td>
            <td>
              {beneficiary.type}
            </td>
            <td>
              {beneficiary.amountType}
            </td>
            <td>
               {beneficiary.amountType === 'Max' ? '' : `$${beneficiary.amount}`}
            </td>
          </tr>
        ))
        :
        <tr><td colSpan={6}>
          <div className={styles.noBeneficiary}>
            <div>No beneficiary entered</div>
            <br />
            <div>
              {this.props.currentFy
                && !this.props.beneficiaryLocked && hasAccess(this.props.currentUser, 'Beneficiary', this.props.history, 'RW', false)
                && this.props.beneficiaries.effectiveDate
                && <Button onClick={this.props.openBeneficiaryForm} type="flat">
                  Add beneficiary
                </Button>
              }
              {this.props.currentFy && this.props.beneficiaryLocked &&
              <span>Beneficiary is currently locked</span>
              }
            </div>
          </div>
        </td></tr>
    )
  }

  render() {
    const confirmBeneficiaryDeleteProps = {
      actions: [
        { label: 'CANCEL', onClick: this._closeConfirmBeneficiaryDeleteDialog },
        { label: 'DELETE', onClick: this._saveConfirmBeneficiaryDeleteDialog },
      ],
      title: 'Are you sure you want to delete this beneficiary?',
      active: this.state.confirmBeneficiaryDeleteDialogOpen,
      onClose: this._closeConfirmBeneficiaryDeleteDialog,
    }
    const confirmBeneficiaryProps = {
      actions: [
        { label: 'CANCEL', onClick: this._closeConfirmBeneficiaryDialog },
        { label: 'CONFIRM', onClick: this._saveConfirmBeneficiaryDialog },
      ],
      title: 'Are you sure you want to confirm this beneficiary?',
      active: this.state.confirmBeneficiaryDialogOpen,
      onClose: this._closeConfirmBeneficiaryDialog,
    }
    return (
      <div>
        <Heading noTopPadding>FY {this.props.beneficiaryYear} </Heading>
        {this.props.subHeading &&
          <div className={styles.subHeadingStyle}>
            <Alert type="info">
            Modification of beneficiary details for {this.props.beneficiaryYear} year is closed from {(this.props.beneficiaries.currentFy.last.end ? format(new Date(this.props.beneficiaries.currentFy.last.end), constants.DATE_FORMAT.STANDARD_AU_FULLMONTH) : '')}.
            For further information please contact partnerservices@deloitte.com.au
            </Alert>
          </div>}
        <Card noPadding>
          <Table>
            <thead>
              {this.renderCols()}
            </thead>
            <tbody>
              {this.renderData()}
            </tbody>
          </Table>
          { this.props.currentFy && !this.props.beneficiaryLocked && this.props.beneficiaryItems.length > 0 && hasAccess(this.props.currentUser, 'Beneficiary', this.props.history, 'RW', false) &&
          <CardFooter>
            <div className={classnames(styles.buttonContainer, styles.flexDirection)}>
              <div className={styles.buttonElement1}>
                <Button className={classnames(styles.buttonAction, styles.buttonLeft, styles.buttonBorder)} onClick={this.props.openBeneficiaryForm} type="flat" >
                Modify
              </Button>
              </div>
              <div className={styles.buttonElement2}>
                <Button className={classnames(styles.buttonAction, styles.buttonLeft)} onClick={this._openConfirmBeneficiaryDeleteDialog} type="flat">
                Delete
              </Button>
              </div>
              <div className={styles.buttonElement3}>
                {
                  this.props.currentUser.IsAdmin &&
                  <Button className={classnames(styles.buttonAction, styles.buttonRight)} onClick={this.props.openBeneficiaryCommentForm} type="flat" >
                  Admin Notes
                  </Button>
                }
              </div>
              <div className={styles.buttonElement4}>
                <Button className={classnames(styles.buttonAction, styles.buttonRight)} onClick={this._openConfirmBeneficiaryDialog} type="primary">
                Confirm
              </Button>
              </div>
            </div>
          </CardFooter>
        }
        </Card>
        <Dialog {...confirmBeneficiaryDeleteProps}>You will be not able to bring this back once deleted.</Dialog>
        <Dialog {...confirmBeneficiaryProps}>Are you sure you want to confirm this beneficiary? You will not be able to change this once confirmed.</Dialog>
      </div>
    )
  }
}

export default BeneficiaryList



// WEBPACK FOOTER //
// ./src/views/Beneficiaries/components/Beneficiary/BeneficiaryList.js